import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./RefundTransactionContent.module.scss";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";

import Spin from "components/Spin/Spin";
const PAGE_LOCALE_KEY = "page.transactions.sharedComponents.refundTransaction.";

const RefundTransactionContent = ({ handleInput, data, error, isRefunding }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});
  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  return (
    <div > 
      <div className={s.contentContainer}>  
      
        <OutlinedText
          label={t(PAGE_LOCALE_KEY + "dialog.content.1")}
          errorMessage={
            error.refundAmount
              ? t(PAGE_LOCALE_KEY + "dialog.errorMessage.1")
              : (error.valueExceeded 
                ? t(PAGE_LOCALE_KEY + "dialog.errorMessage.4")
                : t(PAGE_LOCALE_KEY + "dialog.errorMessage.3"))
              
          }
          defaultValue={data.refundAmount ? data.refundAmount : ""}
          value={data.refundAmount}
          onchangeFn={(e) =>
            textInputOnchange(e, "refundAmount")
          }
          onfocusFn={() => textInputOnFocus("refundAmount")}
          onblurFn={() => textInputOnBlur("refundAmount")}
          sxParams={{
            textFocus: focus.refundAmount,
            textError: error.refundAmount || error.valueMismatch || error.valueExceeded,
          }}
        />
        <OutlinedText
          label={t(PAGE_LOCALE_KEY + "dialog.content.2")}
          errorMessage={
            error.refundAmount
              ? t(PAGE_LOCALE_KEY + "dialog.errorMessage.2")
              : t(PAGE_LOCALE_KEY + "dialog.errorMessage.3")
          }
          defaultValue={data.confirmAmount ? data.confirmAmount : ""}
          value={data.confirmAmount}
          onchangeFn={(e) =>
            textInputOnchange(e, "confirmAmount")
          }
          onfocusFn={() => textInputOnFocus("confirmAmount")}
          onblurFn={() => textInputOnBlur("confirmAmount")}
          sxParams={{
            textFocus: focus.confirmAmount,
            textError: error.confirmAmount || error.valueMismatch,
          }}
        />
      </div>
       { isRefunding && 
          <div className={s.spinContainer}>
            <Spin type={"search"}/>
          </div>
       }
    </div>
  );
};

export default RefundTransactionContent;
